import React from "react";
import Loadable from "react-loadable";
// import { log } from "lib/helpers/helpers.js";

import DotSpinner from "@exovera/dot-spinner";

function Loading() {
	return (
		<div className="map__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}

const RussiaMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		russiaMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/russia.js"),
		federalSubjects: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/russia_blob.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexRussia.js"),
		baseIcon: () => import(/* webpackChunkName: "map" */ "lib/maps/tinyRussia.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const federalSubjects = loaded.federalSubjects.default;
		const mapIndex = loaded.mapIndex.default;
		const baseIcon = loaded.baseIcon.default;
		const russiaMapObject = loaded.russiaMapObject.default;
		// const { reactSimpleMaps } = loaded;

		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				// reactSimpleMaps={reactSimpleMaps}
				baseIcon={baseIcon}
				baseMapObject={russiaMapObject}
				loaderID="RussiaMapLoader"
				states={federalSubjects}
				mapIndex={mapIndex}
				clickableStates={["central", "fareastern", "northcaucasian", "northwestern", "siberian", "southern", "ural", "volga"]}
				clickableStatesReaction={[]}
				// highlightable={[{ name: "Texas 23rd", geoState: "texas23" }]}
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				activeNarrativeData={props.activeNarrativeData}
				clearMap={actions.clearMap}
				mapHighlightDisabled={false}
				mapId="base"
				subtractFromHeight={360}
				// actions
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default RussiaMapLoader;
